import { request } from "@/utilities/libs/request.ts";
import {
  IRequestArgs,
  IResponseData,
  ListResponseData,
} from "@/utilities/types/requests.ts";
import { ERequestMethods } from "@/utilities/enums/RequestMethod.ts";
import {
  EPackageStatus,
  ICreatePackageDTO,
  ICreateUserPackageDTO,
  IPackage,
  IUserPackageResponse,
  IUpdatePackageDTO,
  IUpdateUserPackageDTO,
} from "../types/Package";
import { PACKAGE } from "../enums/Package";

function getPackageList({ queryParams }: IRequestArgs) {
  const query = {
    sort: queryParams?.query?.sort,
    ...queryParams?.query?.search,
    ...queryParams?.pagination,
  };
  return request<ListResponseData<IPackage>>({
    method: ERequestMethods.GET,
    url: PACKAGE.LIST,
    params: query,
  });
}

function getPackageActive() {
  const query = {
    sort: {
      price: "ASC",
      position: "DESC",
    },
    limit: 50,
    page: 1,
    filter: {
      status: EPackageStatus.ACTIVE,
      isHidden: false,
    },
  };
  return request<ListResponseData<IPackage>>({
    method: ERequestMethods.GET,
    url: PACKAGE.LIST,
    params: query,
  });
}

function getPackage(id: string) {
  return request<IResponseData<IPackage>>({
    method: ERequestMethods.GET,
    url: PACKAGE.DETAIL(id),
  });
}

function getPackageByCode(code: string) {
  return request<IResponseData<IPackage>>({
    method: ERequestMethods.GET,
    url: PACKAGE.PACKAGE_BY_CODE(code),
  });
}

function getUserPackage(userId: string) {
  const query = {
    userId: userId,
  };
  return request<IResponseData<IUserPackageResponse>>({
    method: ERequestMethods.GET,
    url: PACKAGE.PACKAGE_BY_USER_ID,
    params: query,
  });
}

function createPackage(data: ICreatePackageDTO) {
  return request<IResponseData<IPackage>>({
    method: ERequestMethods.POST,
    url: PACKAGE.CREATE,
    data,
  });
}

function createUserPackage(data: ICreateUserPackageDTO) {
  return request<IResponseData<IUserPackageResponse>>({
    method: ERequestMethods.POST,
    url: PACKAGE.CREATE_USER_PACKAGE,
    data,
  });
}

function updatePackage(id: string, data: IUpdatePackageDTO) {
  return request<IResponseData<IPackage>>({
    method: ERequestMethods.PUT,
    url: PACKAGE.UPDATE(id),
    data,
  });
}

function updateUserPackage(userPkgId: string, data: IUpdateUserPackageDTO) {
  return request<IResponseData<IUserPackageResponse>>({
    method: ERequestMethods.PATCH,
    url: PACKAGE.UPDATE_USER_PACKAGE(userPkgId),
    data,
  });
}

function deletePackage(id: string) {
  return request<IResponseData<IPackage>>({
    method: ERequestMethods.DELETE,
    url: PACKAGE.DELETE(id),
  });
}

function deleteUserPackage(userPackageId: string) {
  return request<IResponseData<IPackage>>({
    method: ERequestMethods.DELETE,
    url: PACKAGE.DELETE_USER_PACKAGE(userPackageId),
  });
}

const PackageRepository = Object.freeze({
  getPackageList,
  getPackage,
  createPackage,
  createUserPackage,
  updatePackage,
  updateUserPackage,
  deletePackage,
  deleteUserPackage,
  getPackageActive,
  getPackageByCode,
  getUserPackage,
});

export default PackageRepository;
